import React, { Component } from 'react';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import axios from 'axios';

import { TRACKING_CHANGE_URL } from '../../../actions/url'; 

class EditTrackingModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tracking: null,
    }
  }
  componentWillMount() {
  }

  handleSaveButtonClick = () => {
    const { tracking } = this.state;
    axios.post(
      `${TRACKING_CHANGE_URL}${this.props.id}`,
      { tracking },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
    .then((response) => {
      alert(response.data);
      this.props.successSaved();
    }, (err) => {
      alert(err.data);
    });
  }

  handleChange = event => {
    this.setState({tracking: event.target.value});
  }
  
  renderSaveButton() {
    return (
      <div
        style={{
          width: '100%',
          marginTop: '5px',
          alighItems: 'center',
          textAlign: 'center',
        }}
      >
        <Button
          bsStyle="success"
          onClick={this.handleSaveButtonClick}
        >
          <Translate value="save" />
        </Button>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Input
          value={this.state.tracking} 
          name="tracking"
          type="text"
          onChange={this.handleChange}
        />
        { this.renderSaveButton() }
      </div>
    );
  }
}

export default EditTrackingModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/components/EditTrackingModal.jsx